import { CustomCellRendererProps } from 'ag-grid-react';
import { ReactElement } from 'react';
import VehicleInteractionTypeRenderer from '../vehicle-interaction-type/VehicleInteractionTypeRenderer';
import GeofenceInteractionTypeRenderer from '../geofence-interaction-type/GeofenceInteractionTypeRenderer';
import { EmptyCell } from '../../formatters/genericFormatters';
import { AssetInvestigationType } from '@customer/store/apis/investigationsApi';
import { parseInvestigationType } from '@customer/shared/utils/investigationHelper';
import { useTranslation } from 'react-i18next';

export const InvestigationTypeRenderer = ({
  value,
  ...otherProps
}: CustomCellRendererProps<{ it: AssetInvestigationType }, AssetInvestigationType>):
  | ReactElement
  | string => {
  const { t } = useTranslation();

  if (typeof value == 'string') {
    // Pick the right cell renderer based on the type of interaction.
    const { vi, gi, custom } = parseInvestigationType(value);
    if (custom) {
      return t(`Enum.InvestigationType.${AssetInvestigationType.Custom}`);
    } else if (vi) {
      return <VehicleInteractionTypeRenderer {...otherProps} value={vi} />;
    } else if (gi) {
      return <GeofenceInteractionTypeRenderer {...otherProps} value={gi} />;
    }
  }

  return EmptyCell;
};

export default InvestigationTypeRenderer;
